import { getChestcontentSize } from '~/components/Chest/helpers'
import { ChestSize } from '~/components/Chest/types'
import { GemType } from '~/components/Rock/types'
import AnimationGems from '~/shared/components/RewardsChest/AnimationGems'
import AnimationOrbs from '~/shared/components/RewardsChest/AnimationOrbs'
import AnimationXp from '~/shared/components/RewardsChest/AnimationXp'

export default function Rewards({
  rewards,
  rewardSize,
  size = 'small',
}: {
  size?: ChestSize
  rewardSize?: ChestSize
  rewards: {
    xp: number
    gemCount: number
    gemType: GemType
    kudos: number
  }
}): React.ReactElement {
  const scaleSize = rewardSize ? getChestcontentSize(rewardSize) : getChestcontentSize(size)
  return (
    <div className={`relative z-10 ${scaleSize ? scaleSize : ''}`}>
      {rewards.gemCount > 0 && <AnimationGems gemType={rewards.gemType} noOfGems={rewards.gemCount} />}
      {rewards.xp > 0 && <AnimationXp noOfXPs={rewards.xp} />}
      {rewards.kudos > 0 && <AnimationOrbs noOfKudos={rewards.kudos} />}
    </div>
  )
}
